<template>
  <section>
    <b-card no-body>
      <div class="m-2">
        <b-row>
          <b-col cols="12" md="12">
            <h2>Patients With Expired Card</h2>
          </b-col>
        </b-row>
        <PatientSearch @values="handleValues">
          <b-button
            @click="getPatientsInfo()"
            style="display: inline"
            class="mt-2"
            variant="primary"
          >
            Search
          </b-button>
          <b-button
            style="display: inline; float: right"
            class="mt-2 ml-2"
            @click="getPatientsInfo(1).then(stopAllCards())"
            variant="danger"
          >
            Stop All Cards
          </b-button>
        </PatientSearch>
      </div>
      <div class="m-2">
        <b-row>
          <b-col>
            <b-table
              :items="patientData"
              responsive
              :fields="tableColumns"
              primary-key="id"
              class="position-relative"
              show-empty
              empty-text="No matching patients found"
              v-if="!loading"
            >
              <template #cell(name)="data">
                <h5 v-if="data.item.patient" class="text-nowrap">
                  <span v-if="data.item.patient.first_name">{{
                    data.item.patient.first_name + " "
                  }}</span>
                  <span v-if="data.item.patient.second_name">{{
                    data.item.patient.second_name + " "
                  }}</span>
                  <span v-if="data.item.patient.third_name">{{
                    data.item.patient.third_name + " "
                  }}</span>
                  <span v-if="data.item.patient.forth_name">{{
                    data.item.patient.forth_name
                  }}</span>
                </h5>
              </template>
              <template #cell(phone)="data">
                <span v-if="data.item.patient" class="text-nowrap">
                  {{ data.item.patient.phone }}
                </span>
              </template>
              <template #cell(age)="data">
                <span v-if="data.item.patient" class="text-nowrap">
                  {{ data.item.patient.age }}
                </span>
              </template>
              <template v-if="" #cell(mother_name)="data">
                <span v-if="data.item.patient" class="text-nowrap">
                  {{
                    data.item.patient.first_mother_name +
                    " " +
                    data.item.patient.second_mother_name
                  }}
                </span>
              </template>
              <template #cell(actions)="data">
                <div class="text-nowrap">
                  <b-button class="mb-75" @click="stopCard(data.item.id)"
                    >Stop Card</b-button
                  >
                </div>
              </template>
            </b-table>
            <template v-if="loading">
              <div>
                <div class="d-flex justify-content-center mb-1">
                  <b-spinner label="Loading..." />
                </div>
              </div>
            </template>
          </b-col>
        </b-row>
      </div>
      <div class="mx-2 mb-2">
        <b-row>
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-start"
          >
            <span class="text-muted">Showing 1 to 10</span>
          </b-col>
          <!-- Pagination -->
          <b-col
            cols="12"
            sm="6"
            class="d-flex align-items-center justify-content-center justify-content-sm-end"
            @click="getTodayDate()"
          >
            <b-pagination
              v-model="page"
              :total-rows="totalRows"
              :per-page="take"
              first-number
              last-number
              class="mb-0 mt-1 mt-sm-0"
              prev-class="prev-item"
              next-class="next-item"
            >
              <template #prev-text>
                <feather-icon icon="ChevronLeftIcon" size="18" />
              </template>
              <template #next-text>
                <feather-icon icon="ChevronRightIcon" size="18" />
              </template>
            </b-pagination>
          </b-col>
        </b-row>
      </div>
    </b-card>
  </section>
</template>

<script>
import {
  BRow,
  BCol,
  BCard,
  BTable,
  BCardBody,
  BTableLite,
  BCardText,
  BButton,
  BAlert,
  BLink,
  VBToggle,
  BFormInput,
  BMedia,
  BAvatar,
  BBadge,
  BDropdown,
  BDropdownItem,
  BPagination,
  BTooltip,
  BFormGroup,
  BFormSelect,
  BSpinner,
  BModal,
} from "bootstrap-vue";
import vSelect from "vue-select";
import { ref, onUnmounted } from "@vue/composition-api";
import store from "@/store";
import router from "@/router";
import Ripple from "vue-ripple-directive";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import permissionChecker from "@/mixins/permissionChecker";
import PatientSearch from "@/components/patientSearch.vue";
export default {
  mixins: [permissionChecker],
  components: {
    BRow,
    BCol,
    BTable,
    BCard,
    BCardBody,
    BTableLite,
    BCardText,
    BButton,
    BAlert,
    BLink,
    vSelect,
    BFormInput,
    BMedia,
    BAvatar,
    BBadge,
    BDropdown,
    BDropdownItem,
    BPagination,
    BTooltip,
    BFormGroup,
    BFormSelect,
    BSpinner,
    BModal,
    PatientSearch,
  },
  directives: {
    Ripple,
    "b-toggle": VBToggle,
  },
  data() {
    return {
      tableColumns: [
        { key: "name", sortable: true },
        { key: "age", sortable: true },
        { key: "phone", sortable: true, class: "text-nowrap" },
        { key: "mother_name", sortable: true },
        { key: "actions" },
      ],
      patientData: [],
      EditForm: {
        first_name: "",
        second_name: "",
        third_name: "",
        forth_name: "",
        first_mother_name: "",
        second_mother_name: "",
        third_mother_name: "",
        forth_mother_name: "",
        national_id: "",
        phone: "",
        second_phone: "",
        age: "",
        adderss: "",
        _method: "PUT",
      },
      page: 1,
      totalRows: "",
      todayDate: "",
      take: 10,
      loading: true,
      selected: "",
      option: [],
      params: {
        form: {},
        path: "",
      },
      patient_id: "",
      fieldValues: {
        first_name: "",
        second_name: "",
        third_name: "",
        forth_name: "",
      },
    };
  },

  mounted() {
    this.getTodayDate();
  },
  methods: {
    handleValues(values) {
      values.first_name
        ? (this.fieldValues.first_name = values.first_name)
        : (this.fieldValues.first_name = "");
      values.second_name
        ? (this.fieldValues.second_name = values.second_name)
        : (this.fieldValues.second_name = "");
      values.third_name
        ? (this.fieldValues.third_name = values.third_name)
        : (this.fieldValues.third_name = "");
      values.forth_name
        ? (this.fieldValues.forth_name = values.forth_name)
        : (this.fieldValues.forth_name = "");
    },
    async getPatientsInfo(takeAll) {
      if (takeAll) {
        this.take = 10000;
      }
      await this.getList(
        `/patient/card?include=patient&is_expired=1&page=${this.page}&take=${this.take}&filter[is_active]=0&filter[patient.first_name]=${this.fieldValues.first_name}&filter[patient.second_name]=${this.fieldValues.second_name}&filter[patient.third_name]=${this.fieldValues.third_name}&filter[patient.forth_name]=${this.fieldValues.forth_name}&sort=-id`
      );
      this.patientData = this.all_data.data;
      this.loading = false;
      this.totalRows = this.all_data.total;
      this.take = 10;
    },
    stopCard(cardId) {
      this.getList(`unactive/patient/card/${cardId}`).then((response) => {
        this.getTodayDate();
        this.$toast({
          component: ToastificationContent,
          position: "top-right",
          props: {
            title: "Card Stopped",
            icon: "info",
            variant: "success",
            text: "Patient Card Stopped successfully",
          },
        });
      });
    },
    stopAllCards() {
      for (let item in this.patientData) {
        this.getList(`unactive/patient/card/${this.patientData[item].id}`).then(() => {
          if (item == this.patientData.length - 1) {
            this.getTodayDate();
            this.$toast({
              component: ToastificationContent,
              position: "top-right",
              props: {
                title: "All Card Stopped",
                icon: "info",
                variant: "success",
                text: "All Patients Cards Stopped successfully",
              },
            });
          }
        });
      }
    },
    async getTodayDate() {
      this.loading = true;
      var today = new Date();
      var dd = String(today.getDate()).padStart(2, "0");
      var mm = String(today.getMonth() + 1).padStart(2, "0"); //January is 0!
      var yyyy = today.getFullYear();
      this.todayDate = yyyy + "-" + mm + "-" + dd;
      this.getPatientsInfo();
    },
  },
};
</script>

<style lang="scss" scoped>
.per-page-selector {
  width: 90px;
}

.invoice-filter-select {
  min-width: 190px;

  ::v-deep .vs__selected-options {
    flex-wrap: nowrap;
  }

  ::v-deep .vs__selected {
    width: 100px;
  }
}

#modal-add___BV_modal_content_ {
  width: 100% !important;
}

#modal-add {
  margin-left: -8% !important;
}
</style>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
